import angular = require("angular");
import TPL = require("templates");
import $ = require("jquery");

/**
  Will apply a class to an element when it is outside of the parent scroll window
  attr param:
    a string, the class to apply

*/
export class FixerDirective {

  restrict = "A";
  link;

  constructor($window, $log) {

    var $el;
    var $viewport;
    var fixerClass;
    var offsetTop;

    this.link = (scope, el, attrs) => {
        $el = $(el);
        $viewport = $($window);//$el.parents("[ng-view]");
        fixerClass = attrs.otFixer;
        //$log.debug("top: " + $el.position().top);
        //$log.debug("height: " + $el.height());
        offsetTop = $el.position().top - $el.height();

        $viewport.on("scroll", function (e) {
          //$log.debug(offsetTop);
          //$log.debug($viewport.scrollTop());
          if ($viewport.scrollTop() >= offsetTop) {
            $el.addClass(fixerClass);
          } else {
            $el.removeClass(fixerClass);
          }
        });
      }
  }

  static factory() {
    var tmp = (a, b) => new FixerDirective(a, b);
    tmp.$inject = ["$window", "$log"];
    return tmp;
  }
}



/** WEBPACK FOOTER **
 ** ./src/scripts/directives/common/fixer.ts
 **/